import React, { useEffect } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
import { Header, Footer } from '@/components';
import { setElementsStylesEnabled } from '@/utils/loadElementsDoc';

import './BaseLayout.less';

export default () => {
  const outlet = useOutlet();
  const location = useLocation();
  const isApiDoc = location.pathname.startsWith('/api/');

  useEffect(() => {
    setElementsStylesEnabled(isApiDoc);
  }, [isApiDoc]);

  return (
    <div className="baseLayout">
      <Header />
      <div className="baseContainer">{outlet}</div>
      <Footer />
    </div>
  );
};
